import { photos } from '../config/photos';
import { applicableImage } from '../helpers/applicable-image/applicable-image';
import { pssImagesUrl } from '../config/pss-images-url';
export const getPhotoUrl = (attributes) => {
    const image = applicableImage(photos, 'photos', attributes, pssImagesUrl);
    return image;
};
//# sourceMappingURL=photo.js.map